/* import "./sass/main.scss" */

import "./js/modal-footer"
import "./js/search-movies";
import './js/modal';
import './js/paginator';
import "./js/draw-page";
import "./js/button-up";